/**
 * Plaintext quick notes (`task.quickNotes`) — the tiny scratch box that
 * replaced the mission's built-in block editor. Deliberately not rich:
 * anything worth formatting belongs in an attached doc.
 */

export function useQuickNotes(localSprint, setLocalSprint, recordAction) {
  const handleQuickNotesChange = (taskId, quickNotes) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldQuickNotes = task?.quickNotes || '';

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t =>
          t.id === taskId ? { ...t, quickNotes, updatedAt: new Date().toISOString() } : t
        ),
      };
    });

    if (recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_QUICK_NOTES',
        description: `${taskName}: Quick notes changed`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, quickNotes: oldQuickNotes } : t),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, quickNotes } : t),
            };
          });
        },
      });
    }
  };

  return { handleQuickNotesChange };
}
